import _ from 'lodash';
import ERRORS from './errorids';
import BaseError from '../errors/baseerror';

export const getErrorsById = (): object => {
	const flattenErrorIds = {};
	const errorKeys = Object.keys(ERRORS);
	for (let i = errorKeys.length - 1; i >= 0; i--) {
		const key = errorKeys[i];
		const currentError = ERRORS[key];
		if (_.isObject(currentError)) {
			const childKeys = Object.keys(currentError);
			for (let j = childKeys.length - 1; j >= 0; j--) {
				const childKey = childKeys[j];
				const newPropertyKey = key + '_' + childKey;
				flattenErrorIds[newPropertyKey] = currentError[childKey];
			}
		} else {
			flattenErrorIds[key] = ERRORS[key];
		}
	}

	return _.invert(flattenErrorIds);
}

export const isNetworkStatusOffline = (error): boolean => {
	// Compare by error message to simplify offline case detection in axios vs superagent
	return error?.message?.toLowerCase().includes('offline') ||
	error?.message?.toLowerCase().includes('request has been terminated') ||
	error?.message?.toLowerCase().includes('network error');
};

export const resolveErrorId = (error):number | undefined => {
	let result:number | undefined;
	if (error instanceof BaseError && error.errorId) {
		result = error.errorId;
	} else if (error.responseText) {
		try {
			const errorResponse = JSON.parse(error.responseText);
			result = errorResponse && (errorResponse.errorid || errorResponse.errorId);
		} catch (err) {
			//silently ignore error, fallback value will be assigned by caller
		}
	} else if (_.get(error, 'response.data')) {
		// error id from axios is saved in response.data
		result = _.get(error, 'response.data.errorid') || _.get(error, 'response.data.errorId');
	} else if (_.get(error, 'response.body')) {
		// error id from superagent is saved in response.body
		result = _.get(error, 'response.body.errorid') || _.get(error, 'response.body.errorId');
	}

	return result;
}


export const extractPropsforAxiosHttpError = (error): object => {
	let errorId: number | undefined;
	let resolvedId: number | undefined;
	const isOffline = isNetworkStatusOffline(error);
	if (isOffline) {
		errorId = ERRORS.OFFLINE;
	} else if (resolvedId = resolveErrorId(error)) {
		errorId = resolvedId;
	} else {
		errorId = ERRORS.XHR_FAILED;
	}
	
	const result = {
		message: isOffline
			?
			'Network Error (6017)'//OFFLINE/CORS/webdev blocked
			:
			error.message || 'unknown-axios-http-error',
		errorId,
		textStatus: _.get(error, 'request.statusText'),
		responseText: _.get(error, 'response.data') || _.get(error, 'request.responseText'),
		status: _.get(error, 'response.status') || _.get(error, 'request.status'),
		responseURL: _.get(error, 'config.url') || error.request.responseURL,
		responseType: _.get(error, 'request.responseType')
	};
	
	return result;
};

export const extractPropsforSuperagentHttpError = (error): object => {
	let errorId: number | undefined;
	let resolvedId: number | undefined;
	const isOffline = isNetworkStatusOffline(error);
	if (isOffline) {
		errorId = ERRORS.OFFLINE;
	} else if (resolvedId = resolveErrorId(error)) {
		errorId = resolvedId;
	} else {
		errorId = ERRORS.XHR_FAILED;
	}
	
	const result = {
		message: isOffline
			?
			'Network Error (6017)'//OFFLINE/CORS/webdev blocked
			:
			error.message || 'unknown-superagent-http-error',
		errorId,
		textStatus: _.get(error, 'response.statusText'),
		responseText: _.get(error, 'response.text'),
		status: _.get(error, 'response.status'),
		responseURL: _.get(error, 'response.error.url') || _.get(error, 'url'),
		responseType: _.get(error, 'response.type')
	};

	return result;
};



// WEBPACK FOOTER //
// ./src/errors/errorhelper.ts